import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: []
})
export class DatepickerComponent implements OnInit {

  @Input() public placeHolder;
  @Input() public group: FormGroup;
  @Input() public control: FormControl;
  @Input() public startView;
  @Input() public min;
  @Input() public max;
  @Input() public noHint?: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  /**Which screen is to show to user like
   * like date picker open with month, day or year screen
   */
  chosenMonthHandler(event, datepicker) {
    if (this.startView === 'year') {
      this.control.setValue(event);
      datepicker.close();
    }
  }

}
